// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".iconLink{align-items:center;color:#582c83;display:flex;font-size:1.4rem;font-weight:700;line-height:1.8rem;position:relative;width:-moz-fit-content;width:fit-content}.iconLink span{font-size:1rem;line-height:1rem;margin-left:.6rem}.iconLink--reversed{color:#171933;flex-direction:row-reverse}.iconLink--reversed span{color:#ff6e00;font-size:2rem;line-height:2rem;margin-left:0;margin-right:1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
